export const UPDATE_GLOBAL_COOKIE_OPT_OUT = 'UPDATE_GLOBAL_COOKIE_OPT_OUT';
export const UPDATE_IS_FIRST_VISITOR_SESSION = 'UPDATE_IS_FIRST_VISITOR_SESSION';
export const UPDATE_SHOW_EXIT_INTENT_COOKIE_BANNER = 'UPDATE_SHOW_EXIT_INTENT_COOKIE_BANNER';
export const UPDATE_VISITOR_IDENTIFICATION_ENABLED = 'UPDATE_VISITOR_IDENTIFICATION_ENABLED';